import {Component, OnInit} from '@angular/core';
import {BaseComponent} from "./shared/components/base";
import {Store} from "@ngrx/store";
import {AppState} from "./core/store/core.state";
import {LocalStorageService, NotificationService} from "./core/services";
import {Router} from "@angular/router";
import {SocketService} from "./shared/services/socket.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent extends BaseComponent implements OnInit  {
  constructor(
    protected store: Store<AppState>,
    private router: Router,
    private notificationService: NotificationService,
    protected localStorageService: LocalStorageService,
    private socketService: SocketService,
  ) { super(); }

  ngOnInit(): void {
    this.socketService.setupSocketConnection();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    this.socketService.disconnect();
  }
}
